import React from 'react';
import { useIntl } from 'react-intl';

import { useCurrentTheme } from 'app/shared/theme';
import { Box, Typography } from 'app/shared/components/atoms';

interface Props {
  titleId: string;
  descriptionId: string;
  'data-qaid': string;
}
export const ValuePropWithDescription = ({
  titleId,
  descriptionId,
  'data-qaid': qaId,
}: Props) => {
  const { formatMessage } = useIntl();
  const { colors } = useCurrentTheme();

  return (
    <Box flexDirection="column">
      <Typography
        fontSize="fontSize300"
        fontWeight="semibold"
        color={colors.accent.primaryAccent.base}
        data-qaid={`${qaId}-title`}
      >
        {formatMessage({ id: titleId })}
      </Typography>
      <Typography
        fontSize="fontSize200"
        color={colors.primary.white.base}
        data-qaid={`${qaId}-body`}
      >
        {formatMessage({ id: descriptionId })}
      </Typography>
    </Box>
  );
};
